export default class Page {
  constructor(config) {
    this.total = config.total || 0;
    this.page = config.page || 1;
    this.size = config.size || 10;
    this.loading = false;
  }

  isLastPage() {
    return !(this.total > this.page * this.size)
  }

  isFirstPage() {
    return this.page <= 1;
  }

  maxOffsetRequest() {
    return {
      max: this.size,
      offset: this.size * (this.page - 1)
    }
  }

  pageSizeOffsetRequest() {
    return {
      pageSize: this.size,
      offset: this.size * (this.page - 1)
    }
  }

  pageRequest() {
    return {
      page: this.page - 1,
      size: this.size
    }
  }

  isLoading() {
    return this.loading
  }

  setTotal(total) {
    this.total = total
  }

  setPage(page) {
    this.page = page
  }

  getPage() {
    return this.page
  }

  setSize(size) {
    this.size = size
  }

  getSize() {
    return this.size
  }

  setLoading(loading) {
    this.loading = loading
  }

  next() {
    if (!this.isLastPage()) {
      this.page += 1
      return true
    }
    return false
  }

  prev() {
    if (!this.isFirstPage()) {
      this.page -= 1
      return true
    }
    return false
  }

  isValidPageNumber(n) {
    return n > 0 && n <= this.getLastPageNumber()
      // guard from input decimal
      && Number.isInteger(n)
  }

  getLastPageNumber() {
    return Math.ceil(this.total / this.size)
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js